export default __webpack_public_path__ + "static/media/brago-mobile-2.e7ee8283.png";